import axios from '../../plugins/axios'

// Carga la primera empresa PROPIA del usuario y la deja como negocio activo.
// Se usa como fallback cuando no hay negocio guardado, o cuando el guardado
// no pertenece al usuario actual (cambió de cuenta, sesión antigua, etc.).
const loadFirstOwnBusiness = ({ commit, rootState }) => {
  return axios.get('/client/business/', { params: { owner: rootState.auth.user.id } })
    .then(response => {
      const business = (response.data.results && response.data.results[0]) || null
      commit('SET_CURRENT_BUSINESS', business)
      return response
    })
    .catch(err => err.response)
}

export const setCurrentBusiness = ({ commit, rootState }, value) => {
  if (value) {
    commit('SET_CURRENT_BUSINESS', value)
    return
  }

  const stored = localStorage.getItem('current_business')
  if (stored) {
    const business = JSON.parse(stored)
    // Verifica contra el backend que el negocio guardado sea accesible por
    // este usuario. Si no lo es (404/403), NO lo dejamos activo: caemos a la
    // empresa propia. Así, al cambiar de cuenta, no queda apuntando a la
    // empresa del usuario anterior (que respondía 403 en todo).
    return axios.get(`/client/business/${business.id}/`, { params: { owner: rootState.auth.user.id } })
      .then(response => {
        commit('SET_CURRENT_BUSINESS', response.data)
        return response
      })
      .catch(() => loadFirstOwnBusiness({ commit, rootState }))
  }

  return loadFirstOwnBusiness({ commit, rootState })
}
